import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/modules/material/material-module.module';

@Component({
  selector: 'app-mfa-unenroll',
  templateUrl: './mfa-unenroll.component.html',
  styleUrls: ['./mfa-unenroll.component.scss'],
  standalone: true,
  imports: [TranslateModule, MaterialModule, FormsModule, ReactiveFormsModule],
})
export class MfaUnenrollComponent {
  confirmed: boolean = false;

  constructor(public matDialogRef: MatDialogRef<MfaUnenrollComponent>) {}
}
